module.exports = __webpack_public_path__ + "img/symbol_14.a22e3e1b.png";